import anime from "animejs";
import { shuffle } from "underscore";

const directionMap = {
  tl: [-1, -1],
  t: [-1, 0],
  tr: [-1, 1],
  l: [0, -1],
  r: [0, 1],
  bl: [1, -1],
  b: [1, 0],
  br: [1, 1],
};

const DISTANCE = 200;

function getTranslateDirection(direction, distance = DISTANCE) {
  if (!directionMap.hasOwnProperty(direction)) return [1 * distance, 0];

  let dirX = directionMap[direction][1] * distance;
  let dirY = directionMap[direction][0] * distance;

  return [dirX, dirY];
}

export function fadeIn(element, direction = "t") {
  let translateDirection = getTranslateDirection(direction);
  let translateX =
    translateDirection[0] !== 0 ? translateDirection[0] : undefined;
  let translateY =
    translateDirection[1] !== 0 ? translateDirection[1] : undefined;

  anime({
    targets: element,
    opacity: [0, 1],
    translateX: [translateX, 0],
    translateY: [translateY, 0],
    duration: 1000,
    easing: "easeInOutSine",
    complete: function () {
      element.style = "";
    },
  });
}

export function fadeOut(element, direction = "t") {
  let translateDirection = getTranslateDirection(direction);
  let translateX =
    translateDirection[0] !== 0 ? translateDirection[0] : undefined;
  let translateY =
    translateDirection[1] !== 0 ? translateDirection[1] : undefined;

  anime({
    targets: element,
    opacity: [1, 0],
    translateX: [translateX, 0],
    translateY: [translateY, 0],
    duration: 1000,
    easing: "easeInOutSine",
  });
}

export function fadeInChildren(element, direction = "t", reverse = false) {
  let children = element.querySelectorAll(":scope > *");

  if (reverse) {
    children = Array.from(children).reverse();
  }

  let translateDirection = getTranslateDirection(direction);
  let translateX =
    translateDirection[0] !== 0 ? translateDirection[0] : undefined;
  let translateY =
    translateDirection[1] !== 0 ? translateDirection[1] : undefined;

  anime({
    targets: children,
    opacity: [0, 1],
    translateX: [translateX, 0],
    translateY: [translateY, 0],
    duration: 1000,
    easing: "easeInOutSine",
    delay: anime.stagger(200),
  });
}

export function fadeOutChildren(element, direction, reverse = false) {
  let children = element.querySelectorAll(":scope > *");

  if (reverse) {
    children = Array.from(children).reverse();
  }

  let translateDirection = getTranslateDirection(direction);
  let translateX =
    translateDirection[0] !== 0 ? translateDirection[0] : undefined;
  let translateY =
    translateDirection[1] !== 0 ? translateDirection[1] : undefined;

  anime({
    targets: children,
    opacity: [1, 0],
    translateX: [translateX, 0],
    translateY: [translateY, 0],
    duration: 1000,
    easing: "easeInOutSine",
    delay: anime.stagger(200),
  });
}

export function fadeInChildrenLTR(element) {
  const children = element.querySelectorAll(":scope > *");

  anime({
    targets: children,
    opacity: [0, 1],
    translateX: [-100, 0],
    duration: 1000,
    easing: "easeInOutSine",
    delay: anime.stagger(100),
  });
}

export function fadeInChildrenRTL(element) {
  const children = element.querySelectorAll(":scope > *");

  anime({
    targets: children,
    opacity: [0, 1],
    translateX: [100, 0],
    duration: 1000,
    easing: "easeInOutSine",
    delay: anime.stagger(100),
  });
}

export function slideInImage(element, direction = "t") {
  let translateDirection = getTranslateDirection(direction, 2000);
  let translateX =
    translateDirection[0] !== 0 ? translateDirection[0] : undefined;
  let translateY =
    translateDirection[1] !== 0 ? translateDirection[1] : undefined;

  anime({
    targets: element,
    opacity: [0, 1],
    translateX: [translateX, 0],
    translateY: [translateY, 0],
    easing: "easeInOutSine",
    duration: 1000,
  });
}

export function slideInImageWithShadow(element, direction = "t") {
  let translateDirection = getTranslateDirection(direction, 2000);
  let translateX =
    translateDirection[0] !== 0 ? translateDirection[0] : undefined;
  let translateY =
    translateDirection[1] !== 0 ? translateDirection[1] : undefined;

  anime({
    targets: element,
    opacity: [0, 1],
    translateX: [translateX, 0],
    translateY: [translateY, 0],
    easing: "easeInOutSine",
    duration: 1000,
    complete: function () {
      element.classList.add("animated-shadow");
    },
  });
}

export function animateMastersSVG(element) {
  const mastersGraphic = element;

  const words = mastersGraphic.querySelectorAll(
    ".words > g:not(#masters-logo-text)"
  );
  const shuffledWords = shuffle(words);

  anime({
    targets: shuffledWords,
    opacity: [0, 1],
    duration: 1000,
    easing: "easeInOutSine",
    delay: anime.stagger(200),
  });
}
